import React, { useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

/**
 * A customizable confirm dialog template
 */
const ConfirmDialogTemplate = ({
    title,
    message,
    onConfirm,
    visible,
    setVisible,
    footer,
    noIcon,
    onHide,
    className,
    confirmButtonLabel = "Yes",
    declineButtonLabel = "No",
}) => {
    const defaultFooter = <>
        <Button label={confirmButtonLabel} className="p-button-outlined mr-3" onClick={onConfirm} />
        <Button label={declineButtonLabel} className="p-button-outlined p-button-secondary" onClick={() => setVisible(false)} />
    </>;

    return (
        <Dialog
            header={title}
            message={message}
            visible={visible}
            onHide={() => { onHide ? onHide() : setVisible(false) }}
            footer={footer || defaultFooter}
            className={className}
        >
            {!noIcon && <div className="p-dialog-icon">
                <i className="pi pi-exclamation-triangle"></i>
            </div>}

            <div className="p-dialog-message">
                {message}
            </div>
        </Dialog>
    );
};

export default ConfirmDialogTemplate;
